import { Button, Flex, Typography, telRegex } from '@iheartjane/reefer';
import { Form } from '@iheartjane/reefer-hook-form';

export interface MoreInfoFormData {
  firstName?: string;
  lastName?: string;
  phone?: string;
}

export interface MoreInfoScreenProps {
  /** Optional prop to label the continue button */
  continueLabel?: string;

  /** Function called when 'Cancel' button is clicked */
  onDoneClick?(): void;

  /** Function called on form submit */
  onSubmit(values: MoreInfoFormData): void;

  /** User info */
  user?: MoreInfoFormData;
}

export const MoreInfoScreen = ({
  continueLabel,
  onDoneClick,
  onSubmit,
  user,
}: MoreInfoScreenProps) => {
  return (
    <Form name="user-information" onSubmit={onSubmit}>
      <Flex width="100%" flexDirection="column" alignItems="center">
        <Typography variant="header-bold" textAlign="center" branded>
          Let's make sure we have your information.
        </Typography>
        <Form.NumberField
          width="100%"
          disableMobileInputStyling
          allowLeadingZeros
          autocomplete="off"
          label="Phone number"
          maskFormat="(###) ###-####"
          name="phone"
          my={24}
          pattern={telRegex}
          defaultValue={user?.phone ? parseInt(user.phone) : undefined}
          required
        />
        <Form.TextField
          label="First name"
          name="firstName"
          width="100%"
          disableMobileInputStyling
          defaultValue={user?.firstName}
          required
          mb={24}
        />
        <Form.TextField
          label="Last name"
          name="lastName"
          width="100%"
          disableMobileInputStyling
          defaultValue={user?.lastName}
          required
          mb={24}
        />
        <Form.SubmitButton
          full
          variant="primary"
          label={continueLabel ?? 'Continue'}
          mb={16}
        />
        {onDoneClick && (
          <Button
            full
            variant="secondary"
            label="Cancel"
            onClick={onDoneClick}
          />
        )}
      </Flex>
    </Form>
  );
};
